export const categories = [
    {
        name: 'Bench',
        images: [
            {id: '101', src: 'bench_242.jpg'},
            {id: '102', src: 'bench_240.jpg'},
            {id: '104', src: 'bench_251.jpg'},
            {id: '105', src: 'bench_246.jpg'},
            {id: '106', src: 'bench_obj0.jpg'},
            {id: '107', src: 'bench_259.jpg'},
        ]
    },
    {
        name: 'Cabinet',
        images: [
            {id: '201', src: 'cabinet_215.jpg'},
            {id: '202', src: 'cabinet_216.jpg'},
            {id: '203', src: 'cabinet_213.jpg'},
            {id: '205', src: 'cabinet_212.jpg'},
            {id: '206', src: 'cabinet_204.jpg'},
            {id: '207', src: 'cabinet_211.jpg'},
            {id: '208', src: 'cabinet_205.jpg'},
            {id: '209', src: 'cabinet_208.jpg'},
            {id: '210', src: 'cabinet_209.jpg'},
        ]
    },
    {
        name: 'Car',
        images: [
            {id: '302', src: 'car_38.jpg'},
            {id: '303', src: 'car_36.jpg'},
            {id: '304', src: 'car_30.jpg'},
            {id: '305', src: 'car_25.jpg'},
            {id: '306', src: 'car_0.jpg'},
            {id: '307', src: 'car_27.jpg'},
            {id: '308', src: 'car_26.jpg'},
            {id: '309', src: 'car_32.jpg'},
        ]
    },
    {
        name: 'Cellphone',
        images: [
            {id: '901', src: 'phone_150.jpg'},
            {id: '902', src: 'phone_140.jpg'},
            {id: '903', src: 'phone_149.jpg'},

        ]
    },
    {
        name: 'Chair',
        images: [
            {id: '401', src: 'chair_177.jpg'},
            {id: '402', src: 'chair_163.jpg'},
            {id: '404', src: 'chair_172.jpg'},
            {id: '405', src: 'chair_170.jpg'},
            {id: '406', src: 'chair_164.jpg'},
            {id: '407', src: 'chair_0.jpg'},
            {id: '408', src: 'chair-0.png'},
            {id: '409', src: 'chair-1.png'},
        ]
    },
    {
        name: 'Couch',
        images: [
            {id: '508', src: 'couch_0.jpg'},
            {id: '507', src: 'couch_1.jpg'},
            {id: '502', src: 'couch_9.jpg'},
            {id: '503', src: 'couch_4.jpg'},
            {id: '504', src: 'couch_0.jpg'},
            {id: '505', src: 'couch_1.jpg'},
            {id: '506', src: 'couch_2.jpg'},
        ]
    },
    // {
    //     name: 'Firearm',
    //     images: [//7
    //
    //     ]
    // },
    {
        name: 'Lamp',
        images: [//8
            {id: '602', src: 'lamp_83.jpg'},
            {id: '603', src: 'lamp_85.jpg'},
        ]
    },
    {
        name: 'Monitor',
        images: [//9
            {id: '701', src: 'monitor_66.jpg'},
            {id: '702', src: 'monitor_72.jpg'},
            {id: '703', src: 'monitor_67.jpg'},
            {id: '704', src: 'monitor_71.jpg'},
            {id: '705', src: 'monitor_65.jpg'},
            {id: '706', src: 'monitor_64.jpg'},
            {id: '708', src: 'monitor_75.jpg'},
            {id: '709', src: 'monitor_62.jpg'},
            {id: '710', src: 'monitor_78.jpg'},
        ]
    },
    {
        name: 'Mug',
        images: [
            {id: '801', src: 'mug_view2.png'},
            {id: '802', src: 'mug_127.jpg'},
            {id: '803', src: 'mug_view1.png'},
            {id: '804', src: 'mug_125.jpg'},
            {id: '805', src: 'mug_130.jpg'},
            {id: '806', src: 'mug_view0.png'},
            {id: '808', src: 'mug_0.png'},
            {id: '809', src: 'mug_139.jpg'},
        ]
    },
    {
        name: 'Plane',
        images: [//11
            {id: '1001', src: 'plane_118.jpg'},
            {id: '1002', src: 'plane_108.jpg'},
            {id: '1003', src: 'plane_106.jpg'},
            {id: '1004', src: 'plane_111.jpg'},
            {id: '1005', src: 'plane_100.jpg'},
            {id: '1006', src: 'plane_101.jpg'},
            {id: '1007', src: 'plane_103.jpg'},
            {id: '1008', src: 'plane_102.jpg'},
        ]
    },
    {
        name: 'Speaker',
        images: [//12
            {id: '1101', src: 'speaker_238.jpg'},
        ]
    },
    {
        name: 'Table',
        images: [//13
            {id: '1202', src: 'table_198.jpg'},
            {id: '1203', src: 'table_183.jpg'},
            {id: '1204', src: 'table_187.jpg'},
            {id: '1205', src: 'table_190.jpg'},
            {id: '1206', src: 'table_184.jpg'},
            {id: '1207', src: 'table_185.jpg'},

        ]
    },
    // {
    //     name: 'Watercraft',
    //     images: [//14
    //         // {id: '16', src: '13watercraft.png'},
    //     ]
    // },
];
